import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from "@/components/ui/card";

const PeopleSection = () => {
  return (
    <section id="people" className="bg-dark-300">
      <div className="section-container animate-on-scroll">
        <h2 className="section-title text-center animate-text">The Builder</h2>
        <p className="text-center text-gray-300 max-w-3xl mx-auto mb-12 animate-text" style={{ animationDelay: '0.2s' }}>
          TaskTide AI is a solo operation. One person building real products with working code, local AI, and no venture funding.
        </p>

        <div className="max-w-2xl mx-auto">
          <Card className="card-hover animate-card glass-card">
            <CardContent className="p-8">
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="h-24 w-24 rounded-full bg-gradient-to-br from-tasktide-teal to-tasktide-purple flex items-center justify-center text-white text-2xl font-bold shrink-0">
                  MJ
                </div>
                <div className="text-center md:text-left">
                  <h3 className="text-xl font-semibold text-white mb-1">Mani Jalali</h3>
                  <p className="text-tasktide-teal font-medium mb-3">Founder & Engineer</p>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    PhD in Built Environment (UTS). Operates an autonomous AI pipeline that ships 
                    a working product every hour — complete backend, UI, tests, and a private GitHub repo. 
                    Previous work spans property technology, email automation, and autonomous AI systems. 
                    Every product on this site is real code in a real repo. No landing pages.
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2 justify-center md:justify-start">
                    <span className="px-3 py-1 rounded-full bg-tasktide-teal/10 text-tasktide-teal text-xs border border-tasktide-teal/20">FastAPI</span>
                    <span className="px-3 py-1 rounded-full bg-tasktide-purple/10 text-tasktide-purple text-xs border border-tasktide-purple/20">React</span>
                    <span className="px-3 py-1 rounded-full bg-tasktide-orange/10 text-tasktide-orange text-xs border border-tasktide-orange/20">Local LLMs</span>
                    <span className="px-3 py-1 rounded-full bg-tasktide-blue/10 text-tasktide-blue text-xs border border-tasktide-blue/20">Product Design</span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-12 animate-on-scroll" style={{ animationDelay: '0.3s' }}>
          <Link 
            to="/projects" 
            className="inline-block px-6 py-3 glass-card rounded-lg text-tasktide-teal hover:text-white border border-tasktide-teal/20 hover:border-tasktide-teal/50 transition-colors"
          >
            See What Is Being Built →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PeopleSection;
